import React from 'react';
import styles from './events.module.scss';
import { Container, Row, Col, Image } from 'react-bootstrap';
import postImg1 from '../../assets/images/post1.jpg';

function MoreEvents({ data }) {
  if (!data?.length) return null;
  return (
    <div className={[styles.likeSection, 'py-5 bg-white'].join(' ')}>
      <Container>
        <h4 className="fw800 mb-4 pt-5">You may also like</h4>
        <Row>
          {data.map((event) => (
            <Col md={6} key={event.id}>
              <div className={styles.otherPost}>
                <Image src={event?.logo?.original?.url || postImg1} fluid />
                <h5 className="font-s1 fw800 my-3 w-75">
                  {event?.name?.text || ''}
                </h5>
                <p className="font-s1">{event?.description?.text || ''}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default MoreEvents;
